import { getPaymentMethodLabel } from '../utils';
import { PaymentMethod as PaymentMethodEnum } from '../types';
import './status-tag.css';

const ON_RECEIPT_COLORS = { bg: '#fef3c7', color: '#92400e' };

interface OrderPaymentMethodProps {
  paymentMethod?: string | PaymentMethodEnum | null;
}

export default function OrderPaymentMethod({ paymentMethod }: OrderPaymentMethodProps) {
  const label = getPaymentMethodLabel(paymentMethod ?? undefined);
  const isOnReceipt = paymentMethod === PaymentMethodEnum.ON_RECEIPT;

  if (isOnReceipt) {
    return (
      <span
        className="status-tag"
        style={{ backgroundColor: ON_RECEIPT_COLORS.bg, color: ON_RECEIPT_COLORS.color }}
      >
        {label}
      </span>
    );
  }
  return <>{label}</>;
}
